import { create } from 'zustand';

import { IMetric } from '@src/emp-3.0/types';
import { EMetricBuilderAction } from '@src/pages/metric-templates/types';

interface IMetricBuilderState {
  action: EMetricBuilderAction;
  setAction: (action: EMetricBuilderAction) => void;
  metricData: IMetric | null;
  setMetricData: (metricData: IMetric | null) => void;
  newMetric: () => void;
  editMetric: (metricData: IMetric | null) => void;
}

export const useMetricBuilderStore = create<IMetricBuilderState>((set) => ({
  action: EMetricBuilderAction.NEW,
  setAction: (action: EMetricBuilderAction) => set(() => ({ action })),
  metricData: null,
  setMetricData: (metricData: IMetric | null) => set(() => ({ metricData })),
  newMetric: () =>
    set(() => ({
      action: EMetricBuilderAction.NEW,
      metricData: null,
    })),
  editMetric: (metricData: IMetric | null) =>
    set(() => ({
      action: EMetricBuilderAction.EDIT,
      metricData,
    })),
}));
